import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Your Firebase project config (safe to expose)
const firebaseConfig = {
  apiKey: "AIzaSyDnat4i7SCoviQGRNlUjjXscB4Oa9524ks",
  authDomain: "partywitty-guest.firebaseapp.com",
  projectId: "partywitty-guest",
  storageBucket: "partywitty-guest.appspot.com", // ✅ fixed
  messagingSenderId: "204348211349",
  appId: "1:204348211349:web:e4b6769604f8ea1b155b9c",
  measurementId: "G-NPWHZ6ZKML",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export messaging instance
export const messaging = getMessaging(app);
